import PropTypes from 'prop-types';
import React from 'react';
import StyledTextBlock from './styled-text-block';

const propTypes = {
	background: PropTypes.string,
	blackBorder: PropTypes.bool,
	children: PropTypes.node.isRequired,
	dataTestId: PropTypes.string,
	paddingBottom: PropTypes.bool,
	paddingLeft: PropTypes.bool,
	paddingRight: PropTypes.bool,
	paddingTop: PropTypes.bool,
};

const defaultProps = {
	background: undefined,
	blackBorder: false,
	dataTestId: null,
	paddingBottom: true,
	paddingLeft: true,
	paddingRight: true,
	paddingTop: true,
};

function TextBlock({ children, dataTestId, background, ...props }) {
	const textBlockRef = React.useRef();

	React.useEffect(() => {
		textBlockRef.current.querySelectorAll('h1, h2, h3, h4, h5, h6, p').forEach((el) => {
			if (el.children.length > 0) {
				if (el.children[0].classList.toString().indexOf('fuse-text-block__text-size') > -1) {
					el.classList.add('fuse-text-block__custom-text-size');
				} else if (
					el.children[0].children.length > 0 &&
					el.children[0].children[0].classList.toString().indexOf('fuse-text-block__text-size') > -1
				) {
					el.classList.add('fuse-text-block__custom-text-size');
				}
			}
		} );
			
		textBlockRef.current.querySelectorAll('ul').forEach((ul) => {
			const listTypes = [
				{
					selector: '.fuse-text-block__unordered-list',
					className: 'fuse-text-block__unordered-list--brand-mid',
				},
				{
					selector: '.fuse-text-block__unordered-ticklist',
					className: 'fuse-text-block__unordered-ticklist--tick',
					spanContent: 'Tick Icon',				
				},
				{
					selector: '.fuse-text-block__unordered-crosslist',
					className: 'fuse-text-block__unordered-crosslist--cross',
					spanContent: 'Cross Icon',						
				},
			];

			listTypes.forEach(({ selector, className, spanContent }) => {
				if (ul.querySelector(selector)) {
					ul.classList.add( className );
					if(!background){
						ul.querySelectorAll(':scope > li').forEach( (li) =>{
							if( spanContent){
								li.insertAdjacentHTML(
									'afterbegin',
									`<span class="visually-hidden">${ spanContent }</span>`,
								);
							}						
						});
					}
				}
			});			
		});

	}, []);

	return (
		<StyledTextBlock
			className="fuse-text-block"
			data-testid={ dataTestId }
			background={background}
			ref={textBlockRef}
			{...props}
		>
			{children}
		</StyledTextBlock>
	);
}

TextBlock.propTypes = propTypes;
TextBlock.defaultProps = defaultProps;

export { TextBlock };

export default TextBlock;
